import React from 'react';
import { Video } from 'lucide-react';
import GradientButtonCentered from '@/components/ui/GradientButtonCentered';
import { FilterOption } from '@/components/ui/FilterDropdown';

interface VideoGenerateFormProps {
  videoDescription: string;
  isGenerating: boolean;
  hasAudio: boolean;
  styleOptions: FilterOption[];
  selectedStyle: string | null;
  influenceOptions: FilterOption[];
  selectedInfluence: string | null;
  colorOptions: FilterOption[];
  backgroundOptions: FilterOption[];
  selectedBackground: string | null;
  environmentOptions: FilterOption[];
  moodOptions: FilterOption[];
  onGenerate: () => void;
}

const VideoGenerateForm: React.FC<VideoGenerateFormProps> = ({ 
  videoDescription,
  isGenerating,
  onGenerate
}) => {
  // Check if the description has at least 5 words
  const wordCount = videoDescription.trim().split(/\s+/).filter(word => word.length > 0).length;
  const hasMinimumWords = wordCount >= 5;
  
  return (
    <div className="flex justify-center mt-6">
      <GradientButtonCentered 
        onClick={onGenerate}
        disabled={isGenerating || !hasMinimumWords}
        variant="purple"
        icon={<Video className="h-5 w-5" />}
        isLoading={isGenerating}
        fullWidth={true}
        testId="generate-video-button"
      >
        {isGenerating ? 'Generating...' : 'Generate Video'}
      </GradientButtonCentered>
    </div>
  );
};

export default VideoGenerateForm; 